import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { FuseqHeaders } from '../../../FuseQ/fuseq.headers'
import { Observable } from 'rxjs'
import { environment } from '../../../../environments/environment'
@Injectable({
  providedIn: 'root'
})
export class WorkflowManagerApiService {
  constructor (private readonly http: HttpClient, private readonly fuseqHeaders: FuseqHeaders) { }
  getWorkflowList (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/workflow/getWorkflowList`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  getWorkflowActiveList (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/workflow/getWorkflowActiveList`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  getWorkflowJobsList (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/workflow/getWorkflowJobsList`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  showJobsList (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/workflow/showJobsList`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  getWorkflowJobRecordsList (id): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/workflow/getWorkflowJobRecordsList/${id}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  getWfStatusMapping (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/workflow/getWfStatusMapping`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  getWfstatus (id): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/workflow/getWfstatus/${id}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  getDefaultStatus (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/workflow/getDefaultStatus`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  createWorkflow (obj): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/workflow/createWorkflow`
    return this.http.post(APIEndPoint, obj, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  editWorkflow (obj): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/workflow/editWorkflow`
    return this.http.post(APIEndPoint, obj, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  updateWorkFlow (obj): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/workflow/updateWorkFlow`
    return this.http.post(APIEndPoint, obj, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  deleteWorkflow (obj): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/workflow/deleteWorkflow`
    return this.http.post(APIEndPoint, obj, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  resetWorkflow (obj): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/workflow/resetWorkflow`
    return this.http.post(APIEndPoint, obj, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  showWfHistory (workflowId): Observable<any> {
    const obj = { WfId: workflowId }
    const APIEndPoint = `${environment.API_URL}/workflow/showWfHistory`
    return this.http.post(APIEndPoint, obj, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  changeRecordStatus (wfJobId, obj): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/workflow/changeRecordStatus/${wfJobId}`
    return this.http.post(APIEndPoint, obj, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  approveRecord (wfJobId, obj): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/workflow/approveRecord/${wfJobId}`
    return this.http.post(APIEndPoint, obj, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  approveTransaction (wfJobId, obj): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/workflow/approveTransaction/${wfJobId}`
    return this.http.post(APIEndPoint, obj, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  rejectRecord (wfJobId, obj): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/workflow/rejectRecord/${wfJobId}`
    return this.http.post(APIEndPoint, obj, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  startWorkflow (id): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/workflow/startWorkflow/${id}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  scheduleCreate (Payload): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/workflow/scheduleCreate`
    return this.http.post(APIEndPoint, Payload, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  scheduleDelete (ScheduleID: number): Observable<any> {
    const Payload = { Id: ScheduleID }
    const APIEndPoint = `${environment.API_URL}/workflow/scheduleDelete`
    return this.http.post(APIEndPoint, Payload, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  scheduleDeleteAll (IdWorkflow: number): Observable<any> {
    const Payload = { IdWorkflow }
    const APIEndPoint = `${environment.API_URL}/workflow/scheduleDeleteAll`
    return this.http.post(APIEndPoint, Payload, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  scheduleEdit (Payload): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/workflow/schedueEdit`
    return this.http.post(APIEndPoint, Payload, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  scheduleList (Payload) {
    const APIEndPoint = `${environment.API_URL}/workflow/scheduleList`
    return this.http.post(APIEndPoint, Payload, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  workflowTypeList (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/workflow/workflowTypeList`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  workflowTypeCreate (Payload): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/workflow/workflowTypeCreate`
    return this.http.post(APIEndPoint, Payload, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  workflowTypeEdit (Payload): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/workflow/workflowTypeEdit`
    return this.http.post(APIEndPoint, Payload, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  workflowTypeDelete (Payload): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/workflow/workflowTypeDelete`
    return this.http.post(APIEndPoint, Payload, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  workflowType (id): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/workflow/workflowType?Id=${id}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  createRequest (obj): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/workflow/createRequest`
    return this.http.post(APIEndPoint, obj, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  attachmentsList_byIdRecord (IdRecord): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/workflow/attachmentsList_byIdRecord?IdRecord=${IdRecord}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  attachmentCreate (Payload): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/workflow/attachmentCreate`
    return this.http.post(APIEndPoint, Payload, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  attachmentDelete_byId (IdAttachment): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/workflow/attachmentDelete_byId`
    return this.http.post(APIEndPoint, { Id: IdAttachment }, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  Get_SDWANInstallationResult (year): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpSDWAN/Get_SDWANInstallationResult/${year}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  Get_SDWANCheckPianificazioni (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpSDWAN/Get_SDWANCheckPianificazioni`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  Get_SDWANDashboard (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpSDWAN/Get_SDWANDashboard`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  CheckPianificazione (frazionario): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpSDWAN/CheckPianificazione/${frazionario}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  CheckPianificazioneCoworking (frazionario): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpSDWAN/CheckPianificazioneCoworking/${frazionario}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  Update_FM_Metafields (Payload): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpSDWAN/Update_FM_Metafields`
    return this.http.post(APIEndPoint, Payload, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  Schedule_Migrations (Payload): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpSDWAN/Schedule_Migrations`
    return this.http.post(APIEndPoint, Payload, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  Update_VincoloMigrazione (Payload): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpSDWAN/Update_VincoloMigrazione`
    return this.http.post(APIEndPoint, Payload, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  GetTunnelStatus (hostname): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpSDWAN/GetTunnelStatus/${hostname}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  GetFortiDevicesStatus (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpSDWAN/GetFortiDevicesStatus`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  GetDevicesStatus (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpSDWAN/GetDevicesStatus`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  Rollback_Migration (id_wf_record, errorRollback): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpSDWAN/Rollback_Migration/${id_wf_record}`
    return this.http.post(APIEndPoint, { errorRollback }, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  GetSDBQueue (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpSDWAN/getSDBQueue`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  GetSpeedTestQueue (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpSDWAN/getSpeedTestQueue`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  RunSpeedTest (frazionario, type): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpSDWAN/getSpeedTest/${frazionario}/${type}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  GetSpeedTestHistory (frazionario): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpSDWAN/getSpeedTestHistory/${frazionario}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  RunSpeedTestCisco (frazionario, type): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpSDWANCisco/getSpeedTest/${frazionario}/${type}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  GetSpeedTestQueueCisco (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpSDWANCisco/getSpeedTestQueue`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  GetSpeedTestHistoryCisco (frazionario): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpSDWANCisco/getSpeedTestHistory/${frazionario}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  GetTotalSpeedTest (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpSDWAN/getTotalSpeedTest`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  GetTopDownloadSpeedTest (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpSDWAN/getTopDownloadSpeedTest`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  GetTopUploadSpeedTest (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpSDWAN/getTopUploadSpeedTest`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  GetTotalSpeedTestCisco (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpSDWANCisco/getTotalSpeedTest`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  GetTopDownloadSpeedTestCisco (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpSDWANCisco/getTopDownloadSpeedTest`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  GetTopUploadSpeedTestCisco (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpSDWANCisco/getTopUploadSpeedTest`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  GetDevicesHealth (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpSDWANCisco/GetDevicesHealth`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  Rollback_MigrationCisco (id_wf_record, errorRollback): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpSDWANCisco/Rollback_Migration/${id_wf_record}`
    return this.http.post(APIEndPoint, { errorRollback }, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  Update_Password_Global (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpSDWAN/Update_Password_Global`
    return this.http.post(APIEndPoint, {}, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  Get_Release_Global (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpSDWAN/Get_Release_Global`
    return this.http.post(APIEndPoint, {}, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  Update_Password_FEX (fortigate): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpSDWAN/Update_Password_FEX/${fortigate}`
    return this.http.post(APIEndPoint, {}, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  Get_Release_FEX (fortigate): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpSDWAN/Get_Release_FEX/${fortigate}`
    return this.http.post(APIEndPoint, {}, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  Upgrade_FEX (fortigate): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpSDWAN/Upgrade_FEX/${fortigate}`
    return this.http.post(APIEndPoint, {}, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  Get_CoworkingInstallationResult (year): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpSDWAN/Get_CoworkingInstallationResult/${year}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  Get_EstrazioneTunnelSDWANFortinet (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpSDWAN/Get_EstrazioneTunnelSDWANFortinet`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  Get_SDWANCiscoCheckPianificazioni (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpSDWANCisco/Get_SDWANCiscoCheckPianificazioni`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  CheckSwitchConnection (frazionario): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpSDWANCisco/CheckSwitchConnection/${frazionario}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  CheckPianificazioneCisco (frazionario): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpSDWANCisco/CheckPianificazione/${frazionario}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  CheckPianificazioneCoworkingCisco (frazionario): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpSDWANCisco/CheckPianificazioneCoworking/${frazionario}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  Get_SDWANDashboardCisco (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpSDWANCisco/Get_SDWANDashboardCisco`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  GetTunnelStatusCisco (idanagrafica = 0, idRecord = 0): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpSDWANCisco/GetTunnelStatus?id_anagrafica=${idanagrafica}&idRecord=${idRecord}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  Schedule_Migrations_Cisco (Payload): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpSDWANCisco/Schedule_Migrations`
    return this.http.post(APIEndPoint, Payload, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  Update_VincoloMigrazione_Cisco (Payload): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpSDWANCisco/Update_VincoloMigrazione`
    return this.http.post(APIEndPoint, Payload, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  Get_SDWANInstallationResultCisco (year): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpSDWANCisco/Get_SDWANInstallationResultCisco/${year}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  getInfoPerimetro (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpSDWANCisco/getInfoPerimetro`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  getCiscoEdge (deviceUUID): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpSDWANCisco/getCiscoEdge/${deviceUUID}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  getCiscoEdgeStatistics (deviceUUID): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpSDWANCisco/getCiscoEdgeStatistics/${deviceUUID}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  getCiscoEdgeHardware (deviceUUID): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpSDWANCisco/getCiscoEdgeHardware/${deviceUUID}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  getCiscoEdge_switchStatus (deviceUUID): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpSDWANCisco/getCiscoEdge_switchStatus/${deviceUUID}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  getCiscoEdge_port3_4_Status (deviceUUID): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpSDWANCisco/getCiscoEdge_port3_4_Status/${deviceUUID}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }
getCiscoEdge_Traffic (deviceId: string, payload: {  
    last_n_hour?: string;
    start_time?: string | number;
    end_time?: string | number;
  }): Observable<any> {
  const APIEndPoint = `${environment.API_URL}/awpSDWANCisco/getCiscoEdgeTraffic/${deviceId}`;
  return this.http.post(APIEndPoint,payload,this.fuseqHeaders.setTokenHeaders('POST') );
}
  getFortinet_switchStatus (frazionario): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpSDWAN/getFortinet_switchStatus/${frazionario}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  getFortinet_port3_4_Status (frazionario): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpSDWAN/getFortinet_port3_4_Status/${frazionario}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  GetSDBQueueCisco (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpSDWANCisco/getSDBQueue`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  getCiscoManageTasksQueue (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpSDWANCisco/getCiscoManageTasksQueue`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  getDetailCiscoManageTask (idtask): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpSDWANCisco/getDetailCiscoManageTask/${idtask}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  GetAllTunnelsStatus (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpSDWANCisco/GetAllTunnelsStatus`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  PerimetroCiscoA1 (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/vManageActions/perimetroCisco_A1`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  ConfigSwitchTrunk (idanagrafica): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/vManageActions/configSwitch_trunk/${idanagrafica}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  ConfigSwitchAccess (idanagrafica): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/vManageActions/configSwitch_access/${idanagrafica}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  RollbackMigrationAnsible (idanagrafica): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/vManageActions/rollbackMigration_ansible/${idanagrafica}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  DeployConfigGroupInstallation (idanagrafica): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/vManageActions/deployConfigGroup_installation/${idanagrafica}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  DeployConfigGroupMigration (idanagrafica): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/vManageActions/deployConfigGroup_migration/${idanagrafica}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  MigrationAnsible (idanagrafica): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/vManageActions/migration_ansible/${idanagrafica}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  DeployPolicyGroup (idanagrafica): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/vManageActions/deployPolicyGroup/${idanagrafica}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  DeployPolicyCellular (idanagrafica): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/vManageActions/deployPolicyCellular/${idanagrafica}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  UndeployPolicyGroup (idanagrafica): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/vManageActions/undeployPolicyGroup/${idanagrafica}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  create_singleConfigGroup (Payload): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpSDWANCisco/create_singleConfigGroup`
    return this.http.post(APIEndPoint, Payload, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  create_singleConfigGroup_NRD (Payload): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpSDWANCisco/create_singleConfigGroup_NRD`
    return this.http.post(APIEndPoint, Payload, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  Get_Speedtest_Pool (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpSDWAN/Get_Speedtest_Pool`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  Update_Speedtest_Pool (Payload): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpSDWAN/Update_Speedtest_Pool`
    return this.http.post(APIEndPoint, Payload, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  get_FortiGateStatistics (deviceUUID): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpSDWAN/getFortiGateStatistics/${deviceUUID}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  get_FortinetDetails (deviceUUID): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpSDWAN/getFortinetDetails/${deviceUUID}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  get_sla_frazionario (deviceUUID, timeSlaRange): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpSDWAN/getFortinet_slaStatus/${deviceUUID}/${timeSlaRange}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  get_FortiGateBanda (deviceUUID, interval, _interface): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpSDWAN/getFortinet_traffic/${deviceUUID}/${interval}/${_interface}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  get_Fortinet_sdwanRules (deviceUUID): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpSDWAN/getFortinet_sdwanRules/${deviceUUID}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  updateVlanStatusfortinet (Payload): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpSDWAN/updateVlanStatus_fortinet`
    return this.http.post(APIEndPoint, Payload, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  reboot_Fex (Payload): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpSDWAN/rebootFex`
    return this.http.post(APIEndPoint, Payload, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  getFEXInfo (frazionario): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpSDWAN/getFEXInfo`
    return this.http.post(APIEndPoint, { frazionario }, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  setMigrationSDWANFortinet (Payload): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpSDWAN/setMigrationSDWANFortinet`
    return this.http.post(APIEndPoint, Payload, this.fuseqHeaders.setTokenHeaders('POST'))
  }
}
